import React from 'react';
import Codebar from './Codebar';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Preview from './preview.png';

function Code() {
    return (
        <div>
        <Codebar />
        <Jumbotron style={{margin: 0, backgroundColor: 'orange', borderRadius: 0}}>
            <h1 id="csols">Contest Solutions</h1>
            <p>A public GitHub repository coming soon!</p>
        </Jumbotron>
        <Jumbotron style={{margin: 0, backgroundColor: '#32CD32', borderRadius: 0}}>
            <h1 id="kidovid19"><a rel="noopener noreferrer" target="_blank" href="https://www.kidovid19.com" style={{color: "inherit"}}>Kidovid 19</a></h1>
            <p><a rel="noopener noreferrer" target="_blank" class="link" href="https://www.kidovid19.com">kidovid19.com</a> - a kid portal for COVID-19. Reach out to <a class="link" href="mailto:kidovid19@gmail.com">kidovid19@gmail.com</a> if you any questions, concerns, or feedback, or if you wish to collaborate. So far, we have data from the U.S. states, and we aim to display more data fields as well as get data from other parts of the world.</p>
            <ul>
                <li>Made with NodeJS.</li>
            </ul>
            <img width="100%" src={Preview} alt="preview"/>
            
        </Jumbotron>
        </div>
    );
}

export default Code;